module.exports = __webpack_public_path__ + "static/media/CTLA_9-475w.b877461d.webp";